module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveLayout.html -->\n<div class="js-loader loader">\n    '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n</div>\n\n<div class="js-content wrapper wrapper-content wrapper-request-leave"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveLayout.html
// module id = 906
// module chunks = 1